import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import logo from '../assets/LOGO.png';

const MaintenanceMode = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          backgroundColor: 'white',
          maxWidth: '600px',
          width: '90%'
        }}
      >
        <img 
          src={logo} 
          alt="Logo" 
          style={{ 
            width: '120px',
            height: 'auto'
          }}
        />
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ 
            color: '#333',
            fontWeight: '500',
            textAlign: 'left'
          }}
        >
          Vyksta atnaujinimo darbai
        </Typography>
      </Paper>
    </Box>
  );
};

export default MaintenanceMode;
